export const BOOKCLUB_STATUS_BEFORE_RECRUIT = 'BOOKCLUB_STATUS_BEFORE_RECRUIT';
export const BOOKCLUB_STATUS_RECRUITING = 'BOOKCLUB_STATUS_RECRUITING';
export const BOOKCLUB_STATUS_ING = 'BOOKCLUB_STATUS_ING';
export const BOOKCLUB_STATUS_ENDED = 'BOOKCLUB_STATUS_ENDED';

